/**
 * Get the keys that have changed between two objects.
 * @param oldObject Old object to compare
 * @param newObject New object to compare
 * @returns Array of keys that have changed
 */
export function getChangedKeys(oldObject, newObject) {
  var keys = new Set([...Object.keys(oldObject), ...Object.keys(newObject)]);
  var changedKeys = [];
  keys.forEach(key => {
    if (oldObject[key] !== newObject[key]) {
      changedKeys.push(key);
    }
  });
  return changedKeys;
}
export default {
  getChangedKeys
};
//# sourceMappingURL=ObjectUtils.js.map